import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import './Wfh.css';
import $ from 'jquery';
import Loader from '../../StaticComponent/Loader';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import { encryptStorage } from '../../constant';
// import BreadCrumbs from './BreadCrumbs/BreadCrumbs';

import { ExportToCsv } from 'export-to-csv';

import { getLeave, getLeaveType, getstatus, getWfh, getwfhFilter } from '../../service/WfhAPI';
export default function Wfh(props) {
    const navigate = useNavigate();

    const filterData = { domain: '', wfh_status_id: '', start_date: '', end_date: '', leave_status_id: '' };
    let details = { role: '', roleId: '', domain: '' };

    const filterLeave = {
        leave_status_id: '',
        start_date: '',
        end_date: '',
        domain: '',
        leave_type: '',
    };

    const [userInMyWfh, setUserInMyWfh] = useState(false);
    const [userInAllWfh, setuserInAllWfh] = useState(true);
    const [userInMyLeave, setUserInMyLeave] = useState(false);
    const [userInAllLeave, setuserInAllLeave] = useState(true);
    const [searchName, setSearchName] = useState();
    const [filterCheck, setFilterCheck] = useState(false);
    const [searchCheck, setSearchCheck] = useState(false);

    const [empSort, setEmpSort] = useState(false);
    const [dateSort, setDateSort] = useState(false);
    const [statusSort, setStatusSort] = useState(false);
    const [domainSort, setDomainSort] = useState(false);
    const [reportsToSort, setReportsToSort] = useState(false);
    const [typeSort, setTypeSort] = useState(false);
    const [daysSort, setDaysSort] = useState(false);
    const [countSort, setCountSort] = useState(false);

    const [myWfh, setMyWfh] = useState([]);
    const [allWfh, setAllWfh] = useState([]);
    const [userDetails, setUserDetails] = useState(details);
    const [nodata, setNoData] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [filter, setFilter] = useState(userInAllLeave || userInMyLeave ? filterData : filterLeave);
    const [filterValidation, setfilterValidation] = useState('');
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);

    const [myWfhShowMore, setMyWfhShowMore] = useState(10);
    const [allWfhShowMore, setAllWfhShowMore] = useState(10);
    const [myLeaveShowMore, setMyLeaveShowMore] = useState(10);
    const [allLeaveShowMore, setAllLeaveShowMore] = useState(10);
    const [myLeave, setMyLeave] = useState([]);
    const [allLeave, setAllLeave] = useState([]);
    const [leaveType, setleaveType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [wfhStatus, setWfhStatus] = useState([]);
    const [wfhDomain, setWfhDomain] = useState([]);
    const [Tab, setTab] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [ToastValue, setToastValue] = useState('');
    const [ToastColour, setToastColour] = useState('');
    const [ToastParagraph, setToastParagraph] = useState('');

    let search = window.location.search;

    let tab = new URLSearchParams(search).get('tab');
    let isProfile = window.location.href.includes('profile');
    let teamMem = new URLSearchParams(search).get('IsTeamMember');

    //debugger;

    useEffect(() => {
        //debugger;
        if (props?.EmployeeId !== undefined && props?.EmployeeId !== null && props?.Domain !== undefined && props?.Domain !== null) {
            userDetails.roleId = props?.EmployeeId;
            userDetails.role = 'Team Member';
            userDetails.domain = props?.Domain;
            setUserDetails({ ...userDetails });
        } else {
            userDetails.roleId = encryptStorage.getItem('employeeId');
            userDetails.role = encryptStorage.getItem('role');
            userDetails.domain = encryptStorage.getItem('department');
        }

        setUserDetails({ ...userDetails });

        getstatus().then((res) => {
            setWfhStatus(res.data.ResponseData);
            setWfhDomain(res.data.domain);
        });
        getLeaveType().then((res) => {
            setleaveType(res.data.ResponseData);
        });

        //debugger;
        if ((tab == '' || tab == null)) {
            //debugger;
            if (userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' || userDetails.role == 'Manager') {
                allLeaveClicked();
                $('#all_leave_request_tab').addClass('active');
            } else {
                //debugger;
                myLeaveClicked();
                $('#my_leave_request_tab').addClass('active');
            }
        }
        // else if (tab === "Leave" || tab == 'performance' || tab == 'Onboarding' || tab == 'profile' || tab == 'Touchbase' || tab == 'feedback' || tab == 'Salary' || tab == 'Offboard') {
        else if (tab === 'Leave' || isProfile) {
            myLeaveClicked();
            $('#my_leave_request_tab').addClass('active');
            $('#my_leave_request').addClass('active show');
        }

        setShowToast(sessionStorage.getItem('showToast') ? true : false);
        setToastValue(sessionStorage.getItem('showToast') ? sessionStorage.getItem('showToast') : '');
        setToastColour(sessionStorage.getItem('ToastColour') ? sessionStorage.getItem('ToastColour') : '');
        setToastParagraph(sessionStorage.getItem('ToastParagraph') ? sessionStorage.getItem('ToastParagraph') : '');
        if (sessionStorage.getItem('showToast')) {
            setTimeout(() => {
                sessionStorage.removeItem('showToast');
                sessionStorage.removeItem('ToastColour');
                sessionStorage.removeItem('ToastParagraph');
            }, 2500);
        }
    }, []);

    useEffect(() => {
        //debugger

        if (tab) setTab(tab);
        else setTab('');
    }, []);

    useEffect(() => {
        //debugger
        if (Tab == 'allwfh') {
            allWfhClicked();
            $('#wfh_request').addClass('active show');
            $('#wfh_request_tab').addClass('active');
            $('#all_leave_request').removeClass('active');
            $('#all_leave_request_tab').removeClass('active');
        } else if (Tab == 'wfh') {
            myWfhClicked();
            $('#my_wfh_request').addClass('active show');
            $('#my_wfh_request_tab').addClass('active');
            $('#all_leave_request').removeClass('active');
            $('#all_leave_request_tab').removeClass('active');
            $('#wfh_request').removeClass('active show');
            $('#wfh_request_tab').removeClass('active');
            $('#my_leave_request').removeClass('active show');
            $('#my_leave_request_tab').removeClass('active');
        } else if (Tab == 'allLeave') {
            allLeaveClicked();
            $('#all_leave_request').addClass('active show');
            $('#all_leave_request_tab').addClass('active');
            $('#my_wfh_request').removeClass('active show');
            $('#my_wfh_request_tab').removeClass('active');
            $('#wfh_request').removeClass('active show');
            $('#wfh_request_tab').removeClass('active');
            $('#my_leave_request').removeClass('active show');
            $('#my_leave_request_tab').removeClass('active');
        } else if (Tab === 'leave') {
            myLeaveClicked();
            $('#my_leave_request').addClass('active show');
            $('#my_leave_request_tab').addClass('active');
            $('#my_wfh_request').removeClass('active show');
            $('#my_wfh_request_tab').removeClass('active');
            $('#wfh_request').removeClass('active show');
            $('#wfh_request_tab').removeClass('active');
            $('#all_leave_request').removeClass('active show');
            $('#all_leave_request_tab').removeClass('active');
        }
    }, [Tab]);

    const infoForShowMore = (countResult, countToDivid) => {
        //debugger

        let count = countResult;
        let result = count / countToDivid;
        setShowMore(result <= 1 ? false : true);
    };

    const allLeaveClicked = async () => {
        debugger;
        // if (userInAllLeave || userInMyLeave) {
        setuserInAllLeave(true);
        setUserInMyLeave(false);

        setuserInAllWfh(false);
        setUserInMyWfh(false);

        setFilterCheck(false);
        setSearchCheck(false);
        setIsLoading(false);
        // }
        let obj = {
            role: userDetails.role,
            empId: userDetails.roleId,
            limit: 10,
        };
        let leaveResult = await getLeave(obj);
        setAllLeave(leaveResult.data.ResponseData !== 'No data found' ? leaveResult.data.ResponseData : []);
        let noDataValue = leaveResult?.data?.ResponseData?.length == 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(leaveResult.data?.countResult, 10);
        }
        setIsLoading(true);
    };

    const myLeaveClicked = async () => {
        //debugger
        // if (userInAllLeave || userInMyLeave) {
        setIsLoading(false);
        setuserInAllLeave(false);
        setUserInMyLeave(true);

        setuserInAllWfh(false);
        setUserInMyWfh(false);

        setFilterCheck(false);
        setSearchCheck(false);
        // }
        let obj = {
            role: 'Team Member',
            empId: userDetails.roleId,
            limit: 10,
        };
        let LeaveResult = await getLeave(obj);

        //debugger;

        setMyLeave(LeaveResult.data.ResponseData !== 'No data found' || LeaveResult.data.ResponseData ? LeaveResult.data.ResponseData : []);
        let noDataValue = LeaveResult?.data?.ResponseData?.length == 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(LeaveResult.data?.countResult, 10);
        }
        setIsLoading(true);
    };

    const myWfhClicked = async () => {
        //debugger
        // if (userInAllWfh || userInMyWfh) {
        setIsLoading(false);
        setUserInMyWfh(true);
        setuserInAllWfh(false);

        setuserInAllLeave(false);
        setUserInMyLeave(false);

        setFilterCheck(false);
        setSearchCheck(false);
        // }
        let obj = {
            role: 'Team Member',
            empId: userDetails.roleId,
            limit: 10,
        };

        let wfhResult = await getWfh(obj);

        setMyWfh(wfhResult.data.ResponseData !== 'No data found' ? wfhResult.data.ResponseData : []);
        let noDataValue = wfhResult.data.ResponseData.length == 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(wfhResult.data?.countResult, 10);
        }
        setIsLoading(true);
    };

    const allWfhClicked = async () => {
        //debugger
        // if (userInMyWfh || userInAllWfh) {
        setIsLoading(false);

        setuserInAllWfh(true);
        setUserInMyWfh(false);

        setuserInAllLeave(false);
        setUserInMyLeave(false);

        setFilterCheck(false);
        setSearchCheck(false);

        // }
        let obj = {
            role: userDetails.role,
            empId: userDetails.roleId,
            limit: 10,
        };

        let wfhResult = await getWfh(obj);

        setAllWfh(wfhResult.data.ResponseData !== 'No data found' ? wfhResult.data.ResponseData : []);
        let noDataValue = wfhResult.data.ResponseData.length == 0 ? true : false;
        setNoData(noDataValue);
        if (noDataValue) {
            setShowMore(false);
        } else {
            infoForShowMore(wfhResult.data?.countResult, 10);
        }
        setIsLoading(true);
    };

    const myWfhLoad = async () => {
        setIsLoading(false);
        if (filterCheck) {
            let filterCount = myWfhShowMore;
            filterCount += 10;
            setMyWfhShowMore(filterCount);
            let response = await getWfh({ limit: myWfhShowMore, empId: userDetails.roleId, role: userDetails.role, filterData: filter });
            setMyWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, filterCount);
        } else {
            ////debugger
            let loadData = myWfhShowMore + 10;
            setMyWfhShowMore(loadData);
            let obj = {
                role: 'Team Member',
                empId: userDetails.roleId,
                limit: loadData,
            };
            let response = await getWfh(obj);
            setMyWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, loadData);
        }
        setIsLoading(true);
    };

    const allWfhLoad = async () => {
        ////debugger
        setIsLoading(false);
        if (filterCheck || searchCheck) {
            let filterCount = allWfhShowMore;
            filterCount += 10;
            setAllWfhShowMore(filterCount);

            let obj = searchCheck
                ? { limit: filterCount, empId: userDetails.roleId, role: userDetails.role, search: searchName }
                : filterCheck
                ? { limit: filterCount, empId: userDetails.roleId, role: userDetails.role, filterData: filter }
                : {};

            let response = await getWfh(obj);
            setAllWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, filterCount);
        } else {
            ////debugger
            let loadData = allWfhShowMore + 10;
            setAllWfhShowMore(loadData);
            let obj = {
                role: userDetails.role,
                empId: userDetails.roleId,
                limit: loadData,
            };
            let response = await getWfh(obj);
            setAllWfh(response?.data?.ResponseData != 'No data found' ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, loadData);
        }
        setIsLoading(true);
    };

    const myLeaveLoad = async () => {
        setIsLoading(false);
        if (filterCheck) {
            let filterCount = myLeaveShowMore;
            filterCount += 10;
            setMyLeaveShowMore(filterCount);
            let response = await getLeave({
                limit: myLeaveShowMore,
                empId: userDetails.roleId,
                role: userDetails.role,
                filterData: filter,
            });
            setMyLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, filterCount);
        } else {
            ////debugger
            let loadData = myLeaveShowMore + 10;
            setMyLeaveShowMore(loadData);
            let obj = {
                role: 'Team Member',
                empId: userDetails.roleId,
                limit: loadData,
            };
            let response = await getLeave(obj);
            setMyLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, loadData);
        }
        setIsLoading(true);
    };

    const allLeaveLoad = async () => {
        ////debugger
        setIsLoading(false);
        if (filterCheck || searchCheck) {
            let filterCount = allLeaveShowMore;
            filterCount += 10;
            setAllLeaveShowMore(filterCount);
            let obj = searchCheck
                ? {
                      limit: filterCount,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      search: searchName,
                  }
                : filterCheck
                ? { limit: filterCount, empId: userDetails.roleId, role: userDetails.role, filterData: filter }
                : {};
            let response = await getLeave(obj);
            setAllLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, filterCount);
        } else {
            ////debugger
            let loadData = allLeaveShowMore + 10;
            setAllLeaveShowMore(loadData);
            let obj = {
                role: userDetails.role,
                empId: userDetails.roleId,
                limit: loadData,
            };
            let response = await getLeave(obj);
            setAllLeave(response?.data?.ResponseData != 'No data found' ? response.data.ResponseData : null);
            setNoData(response?.data?.ResponseData?.length === 0 ? true : false);
            infoForShowMore(response.data.countResult, loadData);
        }
        setIsLoading(true);
    };

    const viewWfh = (id, tab) => {
        //debugger
        navigate(`/wfhform/${id}`, { state: { switchTab: tab } });
    };

    const viewLeave = (id, tab) => {
        navigate(`/leaveform/${id}`, { state: { switchTab: tab } });
    };

    const bindMyWfh = () => {
        return myWfh?.map((wfh) => {
            let color = wfh.status === 'Pending' ? 'bg-pastel-orange' : wfh.color;
            var tipCount;
            var reasonBind;
            if (wfh.reason.length > 15) {
                reasonBind = wfh.reason.substring(0, 15);
                reasonBind = reasonBind + '...';
                tipCount = 1;
            } else {
                reasonBind = wfh.reason;
                tipCount = 0;
            }
            return (
                <tr className="hive-table-data regular-text align-middle">
                    <td>
                        {moment(wfh.start_date).utc().format('MMM DD')} -{moment(wfh.end_date).utc().format('MMM DD')}
                    </td>
                    <td>{wfh.work_days_count}</td>
                    <td>
                        <a
                            className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={tipCount == 1 ? wfh.reason : ''}
                        >
                            {reasonBind}
                        </a>
                    </td>
                    <td className="text-center bold-text ">
                        <span className={`status-btn ${color} font-12`}>{wfh.status}</span>
                    </td>
                    <td
                        hidden={isProfile ? true : false}
                        onClick={() => {
                            viewWfh(wfh.id, 'wfh');
                        }}
                        className="text-center "
                        style={{ cursor: 'pointer' }}
                    >
                        <a className="text-decoration-none table-link-clr">View</a>
                    </td>
                </tr>
            );
        });
    };

    const bindAllWfh = () => {
        return allWfh?.map((wfh) => {
            var tipCount;
            var reasonBind;
            if (wfh.reason.length > 15) {
                reasonBind = wfh.reason.substring(0, 15);
                reasonBind = reasonBind + '...';
                tipCount = 1;
            } else {
                reasonBind = wfh.reason;
                tipCount = 0;
            }
            let color = wfh.status === 'Pending' ? 'bg-pastel-orange' : wfh.color;
            return (
                <tr className="hive-table-data regular-text align-middle">
                    <td>
                        <div className="d-flex align-items-center">
                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                            <div className="ms-2">
                                <a className="table-name-style mb-0">{wfh.emp_name}</a>
                                <p className="table-domain-style mb-0">{wfh.domain}</p>
                            </div>
                        </div>
                    </td>
                    {userDetails.role === 'Hr Manager' || userDetails.role === 'Hr' ? <td>{wfh.domain}</td> : null}
                    <td>
                        {moment(wfh.start_date).utc().format('MMM DD')} - {moment(wfh.end_date).utc().format('MMM DD')}
                    </td>
                    <td>{wfh.work_days_count}</td>
                    <td>
                        <a
                            className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={tipCount == 1 ? wfh.reason : ''}
                        >
                            {reasonBind}
                        </a>
                    </td>
                    <td className="text-center bold-text ">
                        <span className={`status-btn ${color} font-12`}>{wfh.status}</span>
                    </td>
                    <td
                        hidden={isProfile ? true : false}
                        onClick={() => {
                            viewWfh(wfh.id, 'allwfh');
                        }}
                        className="text-center "
                        style={{ cursor: 'pointer' }}
                    >
                        <a className="text-decoration-none table-link-clr">View</a>
                    </td>
                </tr>
            );
        });
    };

    const bindMyLeave = () => {
        //
        return myLeave?.map((obj) => {
            let color = obj.status.toLowerCase().includes('pending') ? 'bg-pastel-orange' : obj.color;
            var tipCount;
            var reasonBind;
            if (obj.reason.length > 15) {
                reasonBind = obj.reason.substring(0, 15);
                reasonBind = reasonBind + '...';
                tipCount = 1;
            } else {
                reasonBind = obj.reason;
                tipCount = 0;
            }
            return (
                <tr className="hive-table-data regular-text align-middle">
                    {/* <td>
                        <div className="d-flex align-items-center">
                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                            <div className="ms-2">
                                <a href="#" className="table-name-style mb-0">
                                    {obj.emp_name}
                                </a>
                                <p className="table-domain-style mb-0">{obj.domain}</p>
                            </div>
                        </div>
                    </td> */}

                    <td>
                        {moment(obj.start_date).utc().format('MMM DD')} - {moment(obj.end_date).utc().format('MMM DD')}
                    </td>
                    <td>
                        <span className="me-3">
                            <img
                                src="/Images/working-days.svg"
                                alt="working-days"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title
                                data-bs-original-title="Working Days "
                                aria-label="Working Days "
                            />
                            <span className="ms-2 regular-text">{obj.work_days_count}</span>
                        </span>
                        <span>
                            <img
                                src="/Images/holidays.svg"
                                alt="holidays"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title
                                data-bs-original-title="Holidays "
                                aria-label="Holidays "
                            />
                            <span className="ms-2 regular-text">{obj.weekend_days_count}</span>
                        </span>
                    </td>
                    <td>{obj.type}</td>
                    <td>
                        <a
                            className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={tipCount == 1 ? obj.reason : ''}
                        >
                            {reasonBind}
                        </a>
                    </td>
                    <td className="text-center bold-text ">
                        <span className={`status-btn ${color} font-12`}>{obj.status}</span>
                    </td>
                    <td
                        hidden={isProfile ? true : false}
                        onClick={() => {
                            viewLeave(obj.id, 'leave');
                        }}
                        className="text-center "
                        style={{ cursor: 'pointer' }}
                    >
                        <a className="text-decoration-none table-link-clr">View</a>
                    </td>
                </tr>
            );
        });
    };
    const bindAllLeave = () => {
        return allLeave?.map((obj) => {
            var tipCount;
            var reasonBind;
            if (obj.reason.length > 15) {
                reasonBind = obj.reason.substring(0, 15);
                reasonBind = reasonBind + '...';
                tipCount = 1;
            } else {
                reasonBind = obj.reason;
                tipCount = 0;
            }
            let color = obj.status.toLowerCase().includes('pending') ? 'bg-pastel-orange' : obj.color;
            return (
                <tr className="hive-table-data regular-text align-middle">
                    <td>
                        <div className="d-flex align-items-center">
                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                            <div className="ms-2">
                                <a className="table-name-style mb-0">{obj.emp_name}</a>
                                <p className="table-domain-style mb-0">{obj.domain}</p>
                            </div>
                        </div>
                    </td>
                    {userDetails.role === 'Hr Manager' || userDetails.role === 'Hr' ? <td>{obj.domain}</td> : null}
                    {userDetails.role != 'Manager' ? <td>{obj.reports_name}</td> : null}

                    <td>
                        {moment(obj.start_date).utc().format('MMM DD')} - {moment(obj.end_date).utc().format('MMM DD')}
                    </td>

                    <td>
                        <span className="me-3">
                            <img
                                src="/Images/working-days.svg"
                                alt="working-days"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title=""
                                data-bs-original-title="Working Days "
                                aria-label="Working Days "
                            />
                            <span className="ms-2">{obj.work_days_count}</span>
                        </span>
                        <span>
                            <img
                                src="/Images/holidays.svg"
                                alt="holidays"
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                title
                                data-bs-original-title="Holidays "
                                aria-label="Holidays "
                            />
                            <span className="ms-2">{obj.weekend_days_count}</span>
                        </span>
                    </td>

                    <td>{obj.type}</td>
                    <td>
                        <a
                            className={tipCount == 0 ? 'tooltip-color tooltipCursor' : 'tooltip-color'}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={tipCount == 1 ? obj.reason : ''}
                        >
                            {reasonBind}
                        </a>
                    </td>
                    <td className="text-center bold-text ">
                        <span className={`status-btn ${color} font-12`}>{obj.status}</span>
                    </td>
                    <td
                        hidden={isProfile ? true : false}
                        onClick={() => {
                            viewLeave(obj.id, 'allLeave');
                        }}
                        className="text-center "
                        style={{ cursor: 'pointer' }}
                    >
                        <a className="text-decoration-none table-link-clr">View</a>
                    </td>
                </tr>
            );
        });
    };

    const bindstatus = () => {
        return wfhStatus?.map((res) => {
            return <option value={res.id}>{res.status}</option>;
        });
    };

    const binddomain = () => {
        return wfhDomain?.map((res) => {
            return <option value={res.domain}>{res.domain}</option>;
        });
    };

    const filterOnChange = (e) => {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };

    const filterClearClick = () => {
        setFilter(filterData);
        let a = userInAllWfh
            ? allWfhClicked()
            : userInMyWfh
            ? myWfhClicked()
            : userInAllLeave
            ? allLeaveClicked()
            : userInMyLeave
            ? myLeaveClicked()
            : '';

        sethideFilterPopUp(true);
        setfilterValidation('');
    };

    const filterFilterClick = async () => {
        debugger;
        setSearchCheck(searchCheck ? false : false);
        setFilterCheck(true);
        if (filter.start_date != '' && filter.end_date != '') {
            if (Date.parse(filter.start_date) > Date.parse(filter.end_date)) {
                setfilterValidation('From date should be lesser than to date');
                return false;
            }
        }
        setIsLoading(false);

        if (userInAllWfh) {
            setAllWfhShowMore(10);
            let filterCount = 10;
            setFilterCheck(true);
            let response = await getWfh({ limit: filterCount, empId: userDetails.roleId, role: userDetails.role, filterData: filter });
            setAllWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, filterCount);
            }
        } else if (userInMyWfh) {
            setMyWfhShowMore(10);
            let filterCount = 10;
            setFilterCheck(true);
            let response = await getWfh({ limit: filterCount, empId: userDetails.roleId, role: 'Team Member', filterData: filter });
            setMyWfh(response?.data?.ResponseData?.length > 0 ? response?.data?.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, filterCount);
            }
        } else if (userInAllLeave) {
            setAllLeaveShowMore(10);
            let filterCount = 10;
            setFilterCheck(true);
            let response = await getLeave({ limit: filterCount, empId: userDetails.roleId, role: userDetails.role, filterData: filter });
            setAllLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, filterCount);
            }
        } else if (userInMyLeave) {
            setMyLeaveShowMore(10);
            let filterCount = 10;
            setFilterCheck(true);
            let response = await getLeave({ limit: filterCount, empId: userDetails.roleId, role: 'Team Member', filterData: filter });
            setMyLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, filterCount);
            }
        }
        setIsLoading(true);
        sethideFilterPopUp(true);
    };

    const searchByName = async () => {
        setIsLoading(false);
        setFilterCheck(filterCheck ? false : false);
        setSearchCheck(true);

        if (userInAllWfh) {
            setAllWfhShowMore(10);
            let limit = 10;
            let data = {
                empId: userDetails.roleId,
                role: userDetails.role,
                limit: limit,
                search: searchName,
            };

            let searchResult = await getWfh(data);
            setAllWfh(searchResult.data.ResponseData.length > 0 ? searchResult.data.ResponseData : null);
            let noDataValue = searchResult?.data?.ResponseData?.length === 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(searchResult.data?.countResult, limit);
            }
        } else if (userInAllLeave) {
            setAllLeaveShowMore(10);
            let limit = 10;
            let data = {
                empId: userDetails.roleId,
                role: userDetails.role,
                limit: limit,
                search: searchName,
            };
            let searchResult = await getLeave(data);
            setAllLeave(searchResult.data.ResponseData.length > 0 ? searchResult.data.ResponseData : null);
            let noDataValue = searchResult.data.ResponseData.length === 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(searchResult.data?.countResult, limit);
            }
        }
        setIsLoading(true);
    };

    const handleSearchKeyDown = (e) => {
        if (e.charCode == 13) {
            searchByName();
        }
    };

    const sortClicked = async (order, columnName) => {
        setIsLoading(false);
        let sortColumn = columnName;

        let sortBy =
            columnName === 'name'
                ? setEmpSort(!empSort)
                : columnName === 'date'
                ? setDateSort(!dateSort)
                : columnName === 'status'
                ? setStatusSort(!statusSort)
                : null;
        sortBy =
            columnName === 'count'
                ? setCountSort(!countSort)
                : columnName === 'emp_name'
                ? setEmpSort(!empSort)
                : columnName === 'date'
                ? setDateSort(!dateSort)
                : columnName === 'status'
                ? setStatusSort(!statusSort)
                : columnName === 'domain'
                ? setDomainSort(!domainSort)
                : columnName === 'work_days_count'
                ? setDaysSort(!daysSort)
                : columnName === 'type'
                ? setTypeSort(!typeSort)
                : columnName === 'reports_name'
                ? setReportsToSort(!reportsToSort)
                : null;

        if (userInAllWfh) {
            let obj = filterCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      limit: allWfhShowMore,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      filterData: filter,
                  }
                : searchCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      limit: allWfhShowMore,
                      search: searchName,
                  }
                : {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      limit: allWfhShowMore,
                  };
            let response = await getWfh(obj);
            setAllWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, allWfhShowMore);
            }
        } else if (userInMyWfh) {
            let obj = filterCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      limit: myWfhShowMore,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      filterData: filter,
                  }
                : searchCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      limit: myWfhShowMore,
                      search: searchName,
                  }
                : {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      limit: myWfhShowMore,
                  };
            let response = await getWfh(obj);
            setMyWfh(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, myWfhShowMore);
            }
        }

        if (userInAllLeave) {
            let obj = filterCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      limit: allLeaveShowMore,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      filterData: filter,
                  }
                : searchCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      limit: allLeaveShowMore,
                      search: searchName,
                  }
                : {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: userDetails.role,
                      limit: allLeaveShowMore,
                  };
            let response = await getLeave(obj);
            setAllLeave(response.data.ResponseData.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, allLeaveShowMore);
            }
        } else if (userInMyLeave) {
            let obj = filterCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      limit: myLeaveShowMore,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      filterData: filter,
                  }
                : searchCheck
                ? {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      limit: myLeaveShowMore,
                      search: searchName,
                  }
                : {
                      sortColumn: columnName,
                      sortType: order,
                      empId: userDetails.roleId,
                      role: 'Team Member',
                      limit: myLeaveShowMore,
                  };
            let response = await getLeave(obj);
            setMyLeave(response?.data?.ResponseData?.length > 0 ? response.data.ResponseData : null);
            let noDataValue = response?.data?.ResponseData?.length <= 0 ? true : false;
            setNoData(noDataValue);
            if (noDataValue) {
                setShowMore(false);
            } else {
                infoForShowMore(response.data?.countResult, myLeaveShowMore);
            }
        }
        setIsLoading(true);
    };

    const handleExportExcel = async () => {
        //debugger
        //let lastindex = HierArchyID.length - 1;
        //debugger;
        setIsLoading(false);
        try {
            let obj;
            if (userInAllLeave) {
                obj = searchCheck
                    ? {
                          limit: null,
                          empId: userDetails.roleId,
                          role: userDetails.role,
                          search: searchName,
                      }
                    : filterCheck
                    ? { limit: allLeaveShowMore, empId: userDetails.roleId, role: userDetails.role, filterData: filter }
                    : { empId: userDetails.roleId, role: userDetails.role, limit: null };
            } else if (userInAllWfh) {
                obj = searchCheck
                    ? {
                          empId: userDetails.roleId,
                          role: userDetails.role,
                          limit: null,
                          search: searchName,
                      }
                    : filterCheck
                    ? { limit: allWfhShowMore, empId: userDetails.roleId, role: userDetails.role, filterData: filter }
                    : { empId: userDetails.roleId, role: userDetails.role, limit: null };
            }
            //debugger;
            let response = userInAllLeave ? await getLeave(obj) : userInAllWfh ? await getWfh(obj) : null;
            //debugger;
            let user = response.data.ResponseData;
            let exportToExcel = userInAllLeave
                ? [
                      [
                          'Team Members',
                          'Domain',
                          'Reports To',
                          'Start Date',
                          'End Date',
                          'Work Days',
                          'Weekends',
                          'Leave Type',
                          'Reason for Leave',
                          'Status',
                          'Created on',
                      ],
                  ]
                : userInAllWfh
                    ? [['Team Members', 'Domain', 'Start Date', 'End Date', 'Work Days', 'Reason for WFH', 'Status']]
                    : null;

            if (userInAllLeave) {
                //debugger;
                for (var i = 0; i < user.length; i++) {
                    let val = [];
                    val.push(
                        user[i].emp_name,
                        user[i].domain,
                        user[i].reports_name,
                        moment(user[i].start_date).utc().format('MM-DD-YYYY'),
                        moment(user[i].end_date).utc().format('MM-DD-YYYY'),
                        user[i].work_days_count,
                        user[i].weekend_days_count,
                        user[i].type,
                        user[i].reason,
                        user[i].status,
                        moment(user[i].created_at).utc().format('MM-DD-YYYY')
                    );
                    exportToExcel.push(val);
                }
            } else {
                for (var i = 0; i < user.length; i++) {
                    let val = [];
                    val.push(
                        user[i].emp_name,
                        user[i].domain,
                        moment(user[i].start_date).utc().format('MM-DD-YYYY'),
                        moment(user[i].end_date).utc().format('MM-DD-YYYY'),
                        user[i].work_days_count,
                        user[i].reason,
                        user[i].status
                    );
                    exportToExcel.push(val);
                }
            }
            let filename =
                'Leave_Logs' +
                new Date().getFullYear() +
                '' +
                new Date().getMonth() +
                '' +
                new Date().getDate() +
                '' +
                new Date().getHours() +
                '' +
                new Date().getMinutes() +
                '' +
                new Date().getSeconds();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            let ws = XLSX.utils.aoa_to_sheet(exportToExcel);
            // const exportToCSV = (csvData, fileName) => {
            // const ws = XLSX.utils.(csvData);
            const wb = userInAllLeave
                ? { Sheets: { 'View Log': ws }, SheetNames: ['View Log'] }
                : userInAllWfh
                ? { Sheets: { 'View WFH Log': ws }, SheetNames: ['View WFH Log'] }
                : { Sheets: { 'View EMPTY Log': ws }, SheetNames: ['View EMPTY Log'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data1 = new Blob([excelBuffer], { type: fileType });
            //debugger
            FileSaver.saveAs(data1, filename + fileExtension);
            setIsLoading(true);
            // }
            // setIsLoading(true)
        } catch (error) {
        }
    };

    const handleFilterInput = (e) => {
        setfilterValidation('');
        setFilter({ ...filter, [e.target.name]: e.target.value });
    };
    const filterClicked = async () => {
        try {
            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (error) {
            //window.location.href = '/ErrorPage';
        }
    };

    const buildLeaveType = () => {
        return leaveType.map((res) => {
            return <option value={res.id}>{res.type}</option>;
        });
    };

    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview?tab=activities', isActive: true },
        { title: 'Leave', path: '', isActive: false },
    ];

    return (
        <>
            {isProfile ? null : <Loader isLoading={isLoading} />}
            {showToast ? (
                <EvaluationPopUp color={ToastColour} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastParagraph} />
            ) : (
                <></>
            )}
            <div className={`${!isProfile ? 'mt-5' : ''}`}>
                <div className={` row justify-content-center ${!isProfile ? 'mt-5' : 'mt-2'}`}>
                    <div className="col-md-11" hidden={isProfile ? true : false}>
                        <BreadCrumbs data={breadCrumbsData} />
                    </div>
                    <div className={`col-md-11 ${userInAllLeave||userInAllWfh?'wfh-res-flex':"d-flex"}  align-items-center  ${!isProfile ? '' : 'mt-4'} `}>
                        {/*Tab Structure Starts Here*/}
                        <ul className="nav nav-pills " id="pills-tab" role="tablist">
                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' || userDetails.role == 'Manager' ? (
                                <li className="nav-item">
                                    <button
                                        onClick={() => {
                                            allLeaveClicked();
                                        }}
                                        className="nav-link rounded-0 font-14 bold-text active tab-style me-4 pe-0 ps-0"
                                        id="all_leave_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#all_leave_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="all_leave_request"
                                        aria-selected="false"
                                    >
                                        All Leave Requests
                                    </button>
                                </li>
                            ) : null}
                            <li className="nav-item">
                                {isProfile || userDetails.role == 'Team Member' ? (
                                    <button
                                        onClick={() => {
                                            myLeaveClicked();
                                        }}
                                        className={`nav-link rounded-0 font-14 bold-text tab-style me-4 pe-0 ps-0`}
                                        id="my_leave_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#my_leave_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="my_leave_request"
                                        aria-selected="false"
                                    >
                                        Leave Requests
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => {
                                            myLeaveClicked();
                                        }}
                                        className={`nav-link rounded-0 font-14 bold-text tab-style me-4 pe-0 ps-0`}
                                        id="my_leave_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#my_leave_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="my_leave_request"
                                        aria-selected="false"
                                    >
                                        My Leave Requests
                                    </button>
                                )}
                            </li>
                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' || userDetails.role == 'Manager' ? (
                                <li className="nav-item">
                                    <button
                                        onClick={() => {
                                            allWfhClicked();
                                        }}
                                        className="nav-link rounded-0 font-14 bold-text tab-style me-4 pe-0 ps-0"
                                        id="wfh_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#wfh_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="wfh_request"
                                        aria-selected="false"
                                    >
                                        WFH Requests
                                    </button>
                                </li>
                            ) : null}
                            <li className="nav-item">
                                {isProfile || userDetails.role == 'Team Member' ? (
                                    <button
                                        onClick={() => {
                                            myWfhClicked();
                                        }}
                                        className="nav-link rounded-0 font-14 bold-text tab-style me-4 pe-0 ps-0"
                                        id="my_wfh_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#my_wfh_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="my_wfh_request"
                                        aria-selected="false"
                                    >
                                        WFH Requests
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => {
                                            myWfhClicked();
                                        }}
                                        className="nav-link rounded-0 font-14 bold-text tab-style me-4 pe-0 ps-0"
                                        id="my_wfh_request_tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#my_wfh_request"
                                        type="button"
                                        role="tab"
                                        aria-controls="my_wfh_request"
                                        aria-selected="false"
                                    >
                                        My WFH
                                    </button>
                                )}
                            </li>
                        </ul>
                        {/*Tab Structure Ends Here*/}
                        <div className="ms-auto wfh-res-mar-filt  d-flex">
                            {userInAllWfh || userInAllLeave ? (
                                <div className="input-group flex-nowrap search-group me-3">
                                    <input
                                        onChange={(e) => {
                                            setSearchName(e.target.value);
                                        }}
                                        onKeyPress={(e) => handleSearchKeyDown(e)}
                                        type="search"
                                        className="form-control search-align "
                                        placeholder="Search by Team member "
                                        aria-label="Username"
                                        aria-describedby="addon-wrapping"
                                    />
                                    <button
                                        onClick={() => {
                                            searchByName();
                                        }}
                                        className="input-group-text btn btn-search-custom "
                                        id="addon-wrapping"
                                    >
                                        <img src="/Images/search-icon.svg" alt="search-icon" />
                                    </button>
                                </div>
                            ) : null}
                            {/*Filter Section Starts Here*/}
                            <div className="dropdown">
                                <>
                                    <button
                                        style={{ padding: '10px 10px' }}
                                        className="advanced-filter-button me-3 medium-text"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        onClick={() => filterClicked()}
                                    >
                                        <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                        Filter
                                    </button>
                                    {!hideFilterPopUp ? (
                                        <div
                                            className="dropdown-menu px-3 advanced-filter-panel custom-filter-app"
                                            aria-labelledby="dropdownMenuButton1"
                                            style={{ display: 'block', marginTop: '-34px' }}
                                        >
                                            <div className="row">
                                                <div className="col-md-12 py-2 border-0 mb-1">
                                                    <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                    <button
                                                        type="button"
                                                        className="btn-close float-end close-filter"
                                                        data-bs-dismiss="advanced-filter"
                                                        aria-label="Close"
                                                        onClick={() => sethideFilterPopUp(true)}
                                                    />
                                                </div>
                                                <div className="col-md-12 ">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3 ">
                                                            <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                Approval Status
                                                            </label>
                                                            {userInAllWfh || userInMyWfh ? (
                                                                <select
                                                                    className="form-select hive-form-select mt-2"
                                                                    name="wfh_status_id"
                                                                    onChange={(e) => {
                                                                        filterOnChange(e);
                                                                    }}
                                                                    value={filter.wfh_status_id}
                                                                    aria-label="Default select example2"
                                                                    id="Approval_status"
                                                                >
                                                                    <option selected value="">
                                                                        Select
                                                                    </option>
                                                                    {bindstatus()}
                                                                </select>
                                                            ) : userInAllLeave || userInMyLeave ? (
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="leave_status_id"
                                                                    name="leave_status_id"
                                                                    value={filter.leave_status_id}
                                                                    onChange={(e) => handleFilterInput(e)}
                                                                >
                                                                    <option selected value="">
                                                                        Select
                                                                    </option>
                                                                    {bindstatus()}
                                                                </select>
                                                            ) : null}
                                                        </div>
                                                        {userInAllLeave || userInMyLeave ? (
                                                            <>
                                                                <div className="col-md-6 mb-3 ">
                                                                    <label className="form-label hive-form-label" htmlFor="Leave_type">
                                                                        Leave Type
                                                                    </label>
                                                                    <select
                                                                        className="form-select hive-form-select"
                                                                        aria-label="Default select example2"
                                                                        id="Leave_type"
                                                                        name="leave_type"
                                                                        value={filter.leave_type}
                                                                        onChange={(e) => handleFilterInput(e)}
                                                                    >
                                                                        <option selected value="">
                                                                            Select
                                                                        </option>
                                                                        {buildLeaveType()}
                                                                    </select>
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        {(userInAllWfh || userInAllLeave) && userDetails.role != 'Manager' ? (
                                                            <div className="col-md-6 mb-3 ">
                                                                <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                    Domain
                                                                </label>
                                                                {userInAllWfh ? (
                                                                    <select
                                                                        className="form-select hive-form-select mt-2"
                                                                        name="domain"
                                                                        onChange={(e) => {
                                                                            filterOnChange(e);
                                                                        }}
                                                                        value={filter.domain}
                                                                        aria-label="Default select example2"
                                                                        id="Approval_status"
                                                                    >
                                                                        <option selected value="">
                                                                            Select
                                                                        </option>
                                                                        {binddomain()}
                                                                    </select>
                                                                ) : userInAllLeave ? (
                                                                    <select
                                                                        className="form-select hive-form-select"
                                                                        aria-label="Default select example2"
                                                                        id="Domain"
                                                                        name="domain"
                                                                        value={filter.domain}
                                                                        onChange={(e) => handleFilterInput(e)}
                                                                    >
                                                                        <option selected value="">
                                                                            Select
                                                                        </option>
                                                                        {binddomain()}
                                                                    </select>
                                                                ) : null}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                    <div className="col-md-12 pb-2 border-0 ">
                                                        <span className="font-14 semibold-text filter-title">Date Range</span>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                From
                                                            </label>
                                                            <input
                                                                value={filter.start_date}
                                                                name="start_date"
                                                                onChange={(e) => {
                                                                    filterOnChange(e);
                                                                }}
                                                                max={filter.end_date}
                                                                type="date"
                                                                className="form-control hive-form-control mt-2"
                                                                id="fromrange"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="forange">
                                                                To
                                                            </label>
                                                            <input
                                                                value={filter.end_date}
                                                                name="end_date"
                                                                onChange={(e) => {
                                                                    filterOnChange(e);
                                                                }}
                                                                min={filter.start_date}
                                                                type="date"
                                                                className="form-control hive-form-control mt-2"
                                                                id="forange"
                                                            />
                                                        </div>
                                                        <span className="text-danger">{filterValidation}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                                    <button
                                                        onClick={() => {
                                                            filterClearClick();
                                                        }}
                                                        className="btn hive-btn-secondary me-3"
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            filterFilterClick();
                                                        }}
                                                        className="btn hive-btn-primary"
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            </div>
                            {/*Filter Section Ends Here*/}
                            {userInAllWfh || userInAllLeave ? (
                                <button className="btn hive-btn-outline me-3" onClick={() => handleExportExcel()}>
                                    Export to Excel
                                </button>
                            ) : null}
                            {userInAllLeave || userInMyLeave ? (
                                <a
                                    onClick={() => {
                                        if (!isProfile) navigate(`/leaveform`, { state: { switchTab: 'leave' } });
                                        else window.location.href = `/leaveform?IsTeamMember=true`;
                                    }}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <button
                                        className="btn hive-btn-primary"
                                        hidden={teamMem || window.location.href.includes('/leavewfh') ? false : true}
                                    >
                                        <img src="/Images/hive-add-icon.svg" className="me-2" />
                                        Apply for Leave
                                    </button>
                                </a>
                            ) : userInMyWfh || userInAllWfh ? (
                                <a
                                    onClick={() => {
                                        // navigate(`/wfhform`, { state: { switchTab: 'wfh' } })

                                        if (!isProfile) navigate(`/wfhform`, { state: { switchTab: 'wfh' } });
                                        else window.location.href = `/wfhform?IsTeamMember=true`;
                                    }}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <button
                                        className="btn hive-btn-primary"
                                        hidden={teamMem || window.location.href.includes('/leavewfh') ? false : true}
                                    >
                                        <img src="/Images/hive-add-icon.svg" className="me-2" />
                                        Apply for WFH
                                    </button>
                                </a>
                            ) : null}
                        </div>
                    </div>
                    {/*Tab Content Starts Here*/}
                    <div className="col-md-11 mt-4">
                        <div className="tab-content" id="pills-tabContent">
                            {isProfile ? (
                                <div className="row align-items-center justify-content-center">
                                    <div class="col-md-3">
                                        <p class="mb-0 profile-title tt-bold">Leave / WFH Taken</p>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <div className="card profile-border-grey">
                                            <div className="card-body profile-justify-feedback">
                                                <div className="profile-flag-panel">
                                                    <div className="profile-leave-panel profile-leave-green tt-bold">
                                                        {props.leaveCount.casualcount ? props.leaveCount.casualcount : 0}
                                                    </div>
                                                    <div className="text-center mt-2 profile-leave-type">Casual</div>
                                                </div>
                                                <div className="profile-flag-panel">
                                                    <div className="profile-leave-panel profile-leave-yellow tt-bold">
                                                        {props.leaveCount.sickcount ? props.leaveCount.sickcount : 0}
                                                    </div>
                                                    <div className="text-center mt-2 profile-leave-type">Sick</div>
                                                </div>
                                                <div className="profile-flag-panel">
                                                    <div className="profile-leave-panel profile-leave-red tt-bold">
                                                        {props.leaveCount.lopcount ? props.leaveCount.lopcount : 0}
                                                    </div>
                                                    <div className="text-center mt-2 profile-leave-type">LOP</div>
                                                </div>
                                                <div className="profile-flag-panel">
                                                    <div className="profile-leave-panel profile-leave-blue tt-bold">
                                                        {props.leaveCount.wfhcount ? props.leaveCount.wfhcount : 0}
                                                    </div>
                                                    <div className="text-center mt-2 profile-leave-type">WFH</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>{' '}
                                </div>
                            ) : (
                                <></>
                            )}

                            {userDetails.role == 'Hr Manager' || userDetails.role == 'Hr' || userDetails.role == 'Manager' ? (
                                <div
                                    className="tab-pane fade mt-4 active show"
                                    id="all_leave_request"
                                    role="tabpanel"
                                    aria-labelledby="all_leave_request_tab"
                                >
                                    <div className="table-responsive rounded-3">
                                        <table className="table bg-white hive-grid table-borderless ">
                                            <thead className="hive-table-head ">
                                                <tr>
                                                    <th className="bold-text font-12">
                                                        Team Member Name
                                                        <span className="ps-2">
                                                            {empSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'emp_name');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'emp_name');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    {userDetails.role === 'Hr Manager' || userDetails.role === 'Hr' ? (
                                                        <th className="bold-text font-12">
                                                            Domain
                                                            <span className="ps-2">
                                                                {domainSort ? (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('asc', 'domain');
                                                                        }}
                                                                        src="/Images/Sort-up.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('desc', 'domain');
                                                                        }}
                                                                        src="/Images/sort-icon.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                )}
                                                            </span>
                                                        </th>
                                                    ) : null}
                                                    {userDetails.role != 'Manager' ? (
                                                        <th className="bold-text font-12">
                                                            Reports to
                                                            <span className="ps-2">
                                                                {reportsToSort ? (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('asc', 'reports_name');
                                                                        }}
                                                                        src="/Images/Sort-up.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('desc', 'reports_name');
                                                                        }}
                                                                        src="/Images/sort-icon.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                )}
                                                            </span>
                                                        </th>
                                                    ) : null}
                                                    <th className="bold-text font-12">
                                                        Date Range
                                                        <span className="ps-2">
                                                            {dateSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'date');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'date');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        # of Days
                                                        <span className="ps-2">
                                                            {daysSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'work_days_count');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'work_days_count');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        Type
                                                        <span className="ps-2">
                                                            {typeSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'type');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'type');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">Reason</th>
                                                    <th className="text-center bold-text font-12">
                                                        Status
                                                        <span className="ps-2">
                                                            {statusSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'status');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'status');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    <th hidden={isProfile ? true : false} className="text-center bold-text font-12">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>{nodata ?  <tr>
                                                    <td colSpan={9}>
                                                    <div className="text-center w-100">
                                            <img
                                                src="/Images/nodatafound.png"
                                                alt="nodatafound"
                                                className="nofeedbackimg-sty custom-noda-found"
                                            />
                                            <h2 className="tt-bold font-15 text-center margin-negative">No Leave Found</h2>
                                        </div>
                                                    </td>
                                                </tr> : bindAllLeave()}</tbody>
                                        </table>
                                     
                                    </div>


                                    <div className="text-center">
                                        {showMore ? (
                                            <button
                                                onClick={() => {
                                                    allLeaveLoad();
                                                }}
                                                className="btn show-more-btn "
                                            >
                                                Show More
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            ) : null}
                            <div
                                className={
                                    userDetails.role == 'Team Member' && (!tab || tab == 'Leave')
                                        ? `tab-pane fade mt-4 active show`
                                        : `tab-pane fade mt-4`
                                }
                                id="my_leave_request"
                                role="tabpanel"
                                aria-labelledby="my_leave_request_tab"
                            >
                                <div className="table-responsive rounded-3">
                                    <table className="table bg-white hive-grid table-borderless ">
                                        <thead className="hive-table-head ">
                                            <tr>
                                                {/* <th className="bold-text font-12">
                                                        Team Members
                                                        <span className="ps-2">
                                                            <img src="/Images/sort-icon.svg" alt="Sorticon" className="hive-table-sort" />
                                                        </span>
                                                    </th> */}
                                                <th className="bold-text font-12">
                                                    Date Range
                                                    <span className="ps-2">
                                                        {dateSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'date');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'date');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    # of Days
                                                    <span className="ps-2">
                                                        {daysSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'work_days_count');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'work_days_count');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    Type
                                                    <span className="ps-2">
                                                        {typeSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'type');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'type');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>

                                                <th className="bold-text font-12">Reason</th>
                                                <th className="text-center bold-text font-12">
                                                    Status
                                                    <span className="ps-2">
                                                        {statusSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'status');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'status');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>

                                                <th hidden={isProfile ? true : false} className="text-center bold-text font-12">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{nodata ? null : bindMyLeave()}</tbody>
                                    </table>
                                </div>
                                {nodata ? (
                                    <div className="row justify-content-center">
                                        <img
                                            src="/Images/nodatafound.png"
                                            alt="nodatafound"
                                            className="nofeedbackimg-sty custom-nodata-found"
                                        />
                                        <h2 className="tt-bold font-15 text-center margin-negative">No Leave Found</h2>
                                    </div>
                                ) : null}

                                <div className="text-center">
                                    {showMore ? (
                                        <button
                                            onClick={() => {
                                                myLeaveLoad();
                                            }}
                                            className="btn show-more-btn"
                                        >
                                            Show More
                                        </button>
                                    ) : null}
                                </div>
                            </div>

                            {/*WFH Request Section Starts Here*/}
                            {userDetails.role === 'Manager' || userDetails.role === 'Hr Manager' || userDetails.role === 'Hr' ? (
                                <div className="tab-pane fade show" id="wfh_request" role="tabpanel" aria-labelledby="wfh_request_tab">
                                    <div className="table-responsive rounded-3">
                                        <table className="table bg-white hive-grid table-borderless mt-3">
                                            <thead className="hive-table-head ">
                                                <tr>
                                                    <th className="bold-text font-12">
                                                        Team Member Name
                                                        <span className="ps-2">
                                                            {empSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'name');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'name');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    {userDetails.role === 'Hr Manager' || userDetails.role === 'Hr' ? (
                                                        <th className="bold-text font-12">
                                                            Domain{' '}
                                                            <span className="ps-2">
                                                                {domainSort ? (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('asc', 'domain');
                                                                        }}
                                                                        src="/Images/Sort-up.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        onClick={() => {
                                                                            sortClicked('desc', 'domain');
                                                                        }}
                                                                        src="/Images/sort-icon.svg"
                                                                        alt="Sorticon"
                                                                        className="hive-table-sort"
                                                                    />
                                                                )}
                                                            </span>
                                                        </th>
                                                    ) : null}

                                                    <th className="bold-text font-12">
                                                        Date Range
                                                        <span className="ps-2">
                                                            {dateSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'date');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'date');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>

                                                    <th className="bold-text font-12">
                                                        # of Days
                                                        <span className="ps-2">
                                                            {daysSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'work_days_count');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'work_days_count');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>

                                                    <th className="bold-text font-12">Reason</th>
                                                    <th className="text-center bold-text font-12">
                                                        Status
                                                        <span className="ps-2">
                                                            {statusSort ? (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('asc', 'status');
                                                                    }}
                                                                    src="/Images/Sort-up.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img
                                                                    onClick={() => {
                                                                        sortClicked('desc', 'status');
                                                                    }}
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            )}
                                                        </span>
                                                    </th>
                                                    <th hidden={isProfile ? true : false} className="text-center bold-text font-12">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>{nodata ? null : bindAllWfh()}</tbody>
                                        </table>
                                    </div>
                                    {nodata ? (
                                        <div className="row justify-content-center">
                                            <img
                                                src="/Images/nodatafound.png"
                                                alt="nodatafound"
                                                className="nofeedbackimg-sty custom-nodata-found custmargin-negativeom-nodata-found"
                                            />{' '}
                                            <h2 className="tt-bold font-15 text-center margin-negative ">No Wfh Found</h2>
                                        </div>
                                    ) : null}

                                    <div className="text-center">
                                        {showMore ? (
                                            <button
                                                onClick={() => {
                                                    allWfhLoad();
                                                }}
                                                className="btn show-more-btn"
                                            >
                                                Show More
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                            ) : null}
                            {/*WFH Request Section Ends Here*/}
                            {/*My WFH Request Section Starts Here*/}
                            <div
                                className={` ${
                                    userDetails.role == 'Team Member' && tab == 'wfh' ? 'tab-pane fade show active' : 'tab-pane fade show'
                                }`}
                                id="my_wfh_request"
                                role="tabpanel"
                                aria-labelledby="my_wfh_request_tab"
                            >
                                <div className="table-responsive rounded-3">
                                    <table className="table bg-white hive-grid table-borderless mt-3">
                                        <thead className="hive-table-head ">
                                            <tr>
                                                <th className="bold-text font-12">
                                                    Date Range
                                                    <span className="ps-2">
                                                        {dateSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'date');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'date');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    # of Days
                                                    <span className="ps-2">
                                                        {daysSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'work_days_count');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'work_days_count');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">Reason</th>
                                                <th className="text-center bold-text font-12">
                                                    Status
                                                    <span className="ps-2">
                                                        {statusSort ? (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('asc', 'status');
                                                                }}
                                                                src="/Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        ) : (
                                                            <img
                                                                onClick={() => {
                                                                    sortClicked('desc', 'status');
                                                                }}
                                                                src="/Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="hive-table-sort"
                                                            />
                                                        )}
                                                    </span>
                                                </th>
                                                <th hidden={isProfile ? true : false} className="text-center bold-text font-12">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>{nodata ? null : bindMyWfh()}</tbody>
                                    </table>
                                </div>
                                {nodata ? (
                                    <div className="row justify-content-center">
                                        <img
                                            src="/Images/nodatafound.png"
                                            alt="nodatafound"
                                            className="nofeedbackimg-sty custom-nodata-found"
                                        />
                                        <h2 className="tt-bold font-15 text-center margin-negative">No Wfh Found</h2>
                                    </div>
                                ) : null}

                                <div className="text-center">
                                    {showMore ? (
                                        <button
                                            onClick={() => {
                                                myWfhLoad();
                                            }}
                                            className="btn show-more-btn"
                                            style={{ backgroundColor: 'white' }}
                                        >
                                            Show More
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                            {/*My WFH Request Section Ends Here*/}
                        </div>
                        {/*Tab Content Ends Here*/}
                    </div>
                </div>
            </div>
        </>
    );
}
